import SavedSearches from './SavedSearches'

export default SavedSearches
